import { Swiper, SwiperSlide } from "swiper/react";
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import { Box, Chip, IconButton, Typography } from "@material-ui/core";
import { useRef } from "react";
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  dateChip: {
    borderRadius: "8px",
    fontWeight: 500,
    fontSize: "14px",
    padding: theme.spacing(0.5, 2),
    backgroundColor: "#f5f5f5",
    color: "#555",
    boxShadow: "none",
    "&.MuiChip-clickable": {
      cursor: "pointer",
    },
    "&.MuiChip-colorPrimary": {
      backgroundColor: "#fff",
      color: "#000",
      boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
    },
  },
  swiperContainer: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    padding: "4px 8px",
    backgroundColor: "#f8f8f8",
    borderRadius: "12px",
    flex: 1
  },
  dateLabel: {
    fontWeight: 600,
    padding: theme.spacing(1),
    color: "#333",
    marginRight: theme.spacing(1),
    width: "110px"
  }
}));

interface DateNavigatorProps {
  dates: string[]
  selectedIndex: number
  onSelect: (i: number) => void
}

export const DateNavigator = ({ dates, selectedIndex, onSelect }: DateNavigatorProps) => {
  const dateSwiperRef = useRef<any>(null);
  const classes = useStyles();

  const goToPreviousDate = () => {
    const newIndex = Math.max(0, selectedIndex - 1);
    goToIndex(newIndex);
  }

  const goToNextDate = () => {
    const newIndex = Math.min(dates.length - 1, selectedIndex + 1);
    goToIndex(newIndex);
  }

  const goToIndex = (index) => {
    dateSwiperRef?.current?.slideTo(index);
    onSelect(index);
  }

  return (
    <Box display="flex" gridGap="8px" flexDirection="row">
      <Typography variant="body2" className={classes.dateLabel}>
        Select Date :
      </Typography>
      <IconButton onClick={goToPreviousDate} size="small">
        <ArrowBackIcon />
      </IconButton>

      <Swiper
        slidesPerView="auto"
        spaceBetween={8}
        allowTouchMove={false}
        className={classes.swiperContainer}
        onSwiper={(swiper) => (dateSwiperRef.current = swiper)}
      >
        {dates.map((label, i) => (
          <SwiperSlide
            key={i}
            style={{
              width: "auto",
              display: "flex",
              justifyContent: "center",
            }}
          >
            <Chip
              label={label}
              clickable
              color={i === selectedIndex ? "primary" : "default"}
              onClick={() => goToIndex(i)}
              className={classes?.dateChip}
            />
          </SwiperSlide>
        ))}
      </Swiper>

      <IconButton
        onClick={goToNextDate}
        size="small"
      >
        <ArrowForwardIcon />
      </IconButton>
    </Box>)
}